/* @flow */

export const SET_BRAINDATE_NOTIFICATION_COUNT =
  'SET_BRAINDATE_NOTIFICATION_COUNT';
export const RESET_BRAINDATE_NOTIFICATION_COUNT =
  'RESET_BRAINDATE_NOTIFICATION_COUNT';
